import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

import useGlobal from '../../../store';
import ResponseResult from '../../../shared/responses/ResponseResult';
import AutofacturacionUploadForm from './upload/components/AutofacturacionUploadForm';

const mapState = (store) => {
  return {
    upload: store.modulo.autofacturacion.upload,
    archivos: store.modulo.autofacturacion.archivos,
  };
};

const mapActions = (actions) => {
  return {
    upload: actions.modulo.autofacturacion.upload,
    archivos: actions.modulo.autofacturacion.archivos,
  };
};

const AutofacturacionUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result } = state.upload;

  const isValid = !!data.tipo && !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (!busy) {
      props.history.replace('/modulos/autofacturacion/archivos');
    }
  };

  const upload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  useEffect(() => {
    if (!!result && state.archivos.pagination.page === 1) {
      actions.archivos.paginate({});
    }
  }, [result]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!!result) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleClose}
        />
      </div>
    );
  }

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={true}
        centered={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir tickets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AutofacturacionUploadForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={busy || !isValid}
            onClick={upload}
          >
            Subir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AutofacturacionUpload;
